import VMasker from "vanilla-masker";

export const maskCPFHelper = (value) => {
  const mask = VMasker.toPattern(value, "999.999.999-99");

  return mask;
};
